import PropTypes from "prop-types"
import { SortIcon } from "components/Table_SortColumnIcon"
import DragAndDropToggle from "containers/Experiences/dragAndDropToggle"

const categoriesListColumns = handleSort => {
  return [
    {
      text: "",
      dataField: "drag_drop",
      formatter: (cellContent, exp) => <DragAndDropToggle />,
    },
    {
      text: "Category",
      dataField: "name",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, category) => <>{category.name}</>,
      classes: "col-6",
      onSort: (field, order) => {
        handleSort({ o: field, od: order })
      },
    },
    {
      text: "# of Experiences",
      dataField: "events_count",
      formatter: (cellContent, category) => <>{category.events_count}</>,
      classes: "col-6",
    },
  ]
}

categoriesListColumns.propTypes = {
  handleSort: PropTypes.func,
}

export default categoriesListColumns
